<template>
    <div class="inlineblock-meaningless-wrapper">
        <ElPopover
            ref="detailPopover"
            :disabled="!isSettedAlert || isLoadingStatus"
            :visibleArrow="false"
            class="file-wrapper-detail__popover"
            @hide="showFileWrapperDetailDialog = false"
        >
            <ElasticButton
                slot="reference"
                :asyncClick="() => setFileWrapper()"
                :isLoading="isLoadingStatus"
                :title="$t(isIconNeedShine ? 'fileWrapper.alertTip' : 'fileWrapper.tip')"
                :disabledTooltip="disabledTooltip"
                :disabled="false"
                class="pendo-track__function-bar__filewrapper"
            >
                <template #icon>
                    <PtIcon :class="{shine: isIconNeedShine}" icon="SolidEmailAlerts" />
                </template>
                <template #text>
                    {{ $t(isIconNeedShine ? 'fileWrapper.setTitle' : 'fileWrapper.title') }}
                </template>
            </ElasticButton>
            <Detail
                v-if="showFileWrapperDetailDialog"
                :patentId="patentId"
                :alertList="fileWrapperList"
                :patent="patent"
                @addInSuccess="addInSuccess"
                @close="closeDetailPopover"
            />
        </ElPopover>
        <Create
            v-if="patentId && showFileWrapperDialog"
            :showDialog.sync="showFileWrapperDialog"
            :patent="patent"
            :patentNo="patent.PN"
            :patentId="patentId"
            :onChange="onChange"
            mountPoint=".patent-view-app"
            @success="createAlertSuccess"
        />
    </div>
</template>

<script>
import { AlertMixin } from 'library-@/mixins';
import ElasticButton from './ElasticButton';
import { Toast, Icon } from 'patsnap-biz';
import { Popover } from 'element-ui';
import { getFileWrapperList } from '@/lib/api';
import _ from 'lodash';
import Detail from '@/components/file-wrapper-alert/Detail';
import Create from '@/components/file-wrapper-alert/Create';
import { getFileWrapperStatusByApnoApi, getEmailAlertLimitApi } from 'library-@/apis/email_alert_api/email_alert';
import { HOME_URI } from 'library-@/config/apiConfig';
import '@patsnap-ui/icon/assets/solid/EmailAlerts.svg';

let FILE_WRAPPER_LIST_CACHE = null;

export default {
    name: 'FireWrapperAlertComplex',
    components: {
        ElPopover: Popover,
        PtIcon: Icon,
        ElasticButton,
        Detail,
        Create,
    },
    mixins: [AlertMixin],
    props: {
        patentId: {
            type: String,
            required: true,
        },
        patent: {
            type: Object,
            required: true,
            default: () => ({}),
        },
        disabledTooltip: {
            type: Boolean,
            default: false,
        },
        getListTiming: {
            type: String,
            default: 'click',
        },
    },
    data() {
        return {
            isLoadingStatus: false,
            enabledStatus: {},
            comp: undefined,
            showFileWrapperDialog: false,
            showFileWrapperDetailDialog: false,
            showFileWrapperTip: false,
            fileWrapperList: [],
            isIconNeedShine: false,
        };
    },
    computed: {
        isSettedAlert() {
            return this.fileWrapperList.length > 0;
        },
    },
    watch: {
        patentId: {
            immediate: true,
            async handler() {
                this.isLoadingStatus = true;
                if (this.getListTiming === 'mounted') {
                    const [alertStatus] = await Promise.all([this.checkFileWrapperAlert(), this.updateFileWrapperList()]);
                    this.isIconNeedShine = (alertStatus.file_wrapper_status === 'watch');
                } else {
                    const alertStatus = await this.checkFileWrapperAlert();
                    this.isIconNeedShine = (alertStatus.file_wrapper_status === 'watch');
                }
                this.isLoadingStatus = false;
            },
        },
    },
    mounted() {
        // 父级消失 resize 会导致popover 定位至0 0
        window.addEventListener('resize', this.hideDetailPopover);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.hideDetailPopover);
    },
    methods: {
        onChange({ patentId, alertStatus }) {
            this.updateEnableStatusByPatentId(patentId, alertStatus);
        },
        updateEnableStatusByPatentId(patentId, alertStatus) {
            this.enabledStatus = Object.assign({}, this.enabledStatus, {
                [patentId]: alertStatus,
            });
        },
        async setFileWrapper() {
            if (this.isLoadingStatus) return;
            this.isLoadingStatus = true;
            await this.updateFileWrapperList();
            if (!this.isSettedAlert) {
                const { alert_creation } = await getEmailAlertLimitApi();
                if (alert_creation && alert_creation > 0) {
                    window.rvTrack('Open File Wrapper Alert Dialog', {});
                    this.showFileWrapperDialog = true;
                } else {
                    const alertLink = `${HOME_URI}/alert`;
                    Toast({
                        message: this.$t('commonStatusCode.13250130', { link: alertLink }),
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                    });
                }
            } else {
                this.showFileWrapperDetailDialog = true;
            }
            this.isLoadingStatus = false;
            this.removeFileWrapperTip();

            // 再点一下没有反应，需求就是这样的
            // this.showFileWrapperDialog = true;
        },
        removeFileWrapperTip() {
            this.showFileWrapperTip = false;
            localStorage.setItem('noFileWrapperTip', 'true');
        },
        async checkFileWrapperAlert() {
            return await getFileWrapperStatusByApnoApi({ apno: this.patent.APN });
        },
        async updateFileWrapperList() {
            if (FILE_WRAPPER_LIST_CACHE) {
                this.fileWrapperList = _.cloneDeep(FILE_WRAPPER_LIST_CACHE);
            } else {
                this.fileWrapperList = _.cloneDeep(await getFileWrapperList());
                FILE_WRAPPER_LIST_CACHE = _.cloneDeep(this.fileWrapperList);
            }
        },
        closeDetailPopover(isOpenCreate) {
            this.$refs.detailPopover && this.$refs.detailPopover.doClose();
            this.showFileWrapperDialog = isOpenCreate;
        },
        addInSuccess(alertId) {
            this.isIconNeedShine = true;
            const matchItem = this.fileWrapperList.find(item => item.alert_id === alertId);
            if (matchItem) matchItem.apno.push(this.patent.APN);
            FILE_WRAPPER_LIST_CACHE = _.cloneDeep(this.fileWrapperList);
        },
        hideDetailPopover() {
            this.closeDetailPopover(false);
        },
        async createAlertSuccess() {
            this.isIconNeedShine = true;
            this.isLoadingStatus = true;
            FILE_WRAPPER_LIST_CACHE = null;
            await this.updateFileWrapperList();
            this.isLoadingStatus = false;
        },
    },
};
</script>

<style lang="scss">
    .file-wrapper-detail__popover {
        outline: none;
    }
</style>
